<!-- 
배점을 %로 계산하는 평가표 ex) 988

평가점수 기준 : 

점수
우수 : 배점의 100%
양호 : 배점의 75%
보통 : 배점의 50%
미흡 : 배점의 25%
불량 : 배점의 0%

여부
있음 : 배점의 100%
없음 : 배점의 0%

여부 R
없음 : 배점의 100%
있음 : 배점의 0%

건수 
0건 : 배점의 0%
1건 ~ 3건 : 배점의 25%
4건 ~ 6건 : 배점의 50%
7건 ~ 9건 : 배점의 75%
10건 ~ 12건 이상 : 배점의 100%


건수 R
0건 : 배점의 100%
1건 ~ 3건 : 배점의 75%
4건 ~ 6건 : 배점의 50%
7건 ~ 9건 : 배점의 25%
10건 이상 : 배점의 0% 
-->

<template>
  <div>
    <h5 v-if="title" class="my-4"><i class="dot"></i> {{ title }}</h5>
    <table>
      <colgroup>
        <slot name="cols"></slot>
      </colgroup>
      <thead>
        <slot name="head"></slot>
      </thead>
      <tbody>
        <tr v-for="trData in scoreDatas" :class="trData.type === 'title' ? 'tr-title' : ''">
          <slot name="body" :data="trData"></slot>
          <td v-if="trData.maxScore">
            <slot name="scoreSelector" :data="trData" :updateScore="(newValue) => updateScore(newValue, trData)"></slot>
          </td>
          <td v-else-if="trData.type === 'title'"></td>
        </tr>
        <!-- TODO:나중에 Write로 빼기 -->
        <tr class="tr-title">
          <td colspan="3">소계(기본 평가지표)</td>
          <td class="font-medium">100</td>
          <td class="font-medium">{{ score }}</td>
          <td></td>
        </tr>
        <tr class="tr-title" style="background-color: #fffdf1">
          <td colspan="3">가중치(<span style="color: #e42728">가점 Part-1,2)</span></td>
          <td class="font-medium">20</td>
          <td class="font-medium">{{ addScore }}</td>
          <td></td>
        </tr>
        <tr class="tr-title" style="background-color: #f1f3ff">
          <td colspan="3">총계</td>
          <td>120</td>
          <td>{{ totalScore }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: Array,
    placeholder: String,
    isPrint: Boolean,
    readonly: Boolean,
  },
  watch: {
    value: {
      handler(value) {
        this.scoreDatas = value;
      },
    },
    scoreDatas: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      scoreDatas: this.value,
      score: 0,
      addScore: 0,
      totalScore: 0,
    };
  },
  methods: {
    updateScore(value, data) {
      if (value) {
        const maxScore = data.maxScore;
        const processedValue = parseFloat(maxScore * (value.value / 100).toFixed(3));
        const target = this.scoreDatas.find((item) => item === data);
        if (target) {
          this.$set(target, "text4", processedValue);
          this.$set(target, "value", processedValue);
        }
        this.updateTotal();
      }
    },
    updateTotal() {
      // 전체 총점 계산 (addPoint 제외)
      this.score = this.scoreDatas
        .filter((item) => item.type !== "addPoint") // addPoint 제외
        .reduce((sum, item) => sum + (item.value || 0), 0);

      // addPoint만의 총점 계산
      this.addScore = this.scoreDatas
        .filter((item) => item.type === "addPoint") // addPoint만 포함
        .reduce((sum, item) => sum + (item.value || 0), 0);

      this.totalScore = this.score + this.addScore;
      this.$emit("setTotal", { score: this.score, addScore: this.addScore, totalScore: this.totalScore });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    text-align: center;
    padding: 10px 0;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    background-color: #f9f9f9;
  }

  tr {
    td {
      font-weight: 400;
      &:first-child {
        text-align: left;
        padding: 10px 14px !important;
      }
      &:last-child {
        text-align: left;
        padding: 10px;
      }
    }
  }
  .tr-title {
    background-color: #f9f9f9;
    td {
      font-weight: 700;
    }
  }
}
</style>
